(() => {
  const dropdownBtn = document.querySelector('.sidebar-dropdown-btn');
  const dropdownContainer = document.querySelector(
    '.sidebar-dropdown-container'
  );
  const dropdownArrow = document.querySelector('.sidebar-dropdown-btn .far');
  const dropdownActiveText = document.querySelector('.sidebar-dropdown-active');
  const drowdownActiveLink = document.querySelector(
    '.sidebar-dropdown-link-active'
  );
  dropdownActiveText.textContent = drowdownActiveLink.textContent;
  dropdownBtn.addEventListener('click', function() {
    if (dropdownContainer.style.maxHeight) {
      dropdownContainer.style.maxHeight = null;
      dropdownBtn.setAttribute('aria-expanded', 'false');
      dropdownArrow.classList.remove('active');
    } else {
      dropdownContainer.style.maxHeight = dropdownContainer.scrollHeight + 'px';
      dropdownBtn.setAttribute('aria-expanded', 'true');
      dropdownArrow.classList.add('active');
    }
  });
})();
